<ifb-account-notes-sidenav [accountId]="data.account?.id"
                           [notes]="data.account?.notes"
                           [initiator]="data.userCurrent"
                           [saveOnDemand]="true"
                           [innerSidenav]="true">
  <ifc-app-scroll-container [widgetsWithTopHeader]="true">
    <div class="layout margin"
         [@routerTransition]="'fly'">
      <ifb-panel>
        <ifb-card>
          <ifb-account-facility-widget *ngIf="canReadFacility"
                                       [facility]="data.account.facility"
                                       [isEditAllowed]="canEditFacility"></ifb-account-facility-widget>
          <ifb-card *ngIf="canReadOffer">
            <ifc-simple-horizontal-list-widget title="Offer"
                                               [listItems]="offerListItems"
                                               [config]="{ isEditable: canEditOffer }"
                                               (edit)="onEditOffer()">
            </ifc-simple-horizontal-list-widget>
          </ifb-card>
        </ifb-card>
        <ifb-card>
          <ifb-account-state-widget [accountState]="accountStateWidgetData"
                                    [account]="data.account"
                                    [edit]="canEditBalances"
                                    [label]="'Utilization'">
          </ifb-account-state-widget>
            <ifb-account-interest-rate-change-history *ngIf="canReadOffer" [entries]="data.account.offerInterestRateLog">
            </ifb-account-interest-rate-change-history>
        </ifb-card>
      </ifb-panel>
    </div>
  </ifc-app-scroll-container>
</ifb-account-notes-sidenav>
